import { mq } from '../../../cssInJs'
export default {
  summary: mq({
    marginLeft: [0, null, 30],
    border: 'solid 1px #333',
    padding: '0.5rem',
    color: 'white',
    borderRadius: ' 0.5rem',
    background: '#555',
    marginBottom: '0.5rem'
  }),

  totalHdr: {
    fontSize: '1.1rem',
    marginBottom: '0.5rem'
  },

  totalAmount: {
    fontSize: '1.2rem',
    fontWeight: 'bold'
  },

  timerSection: {
    marginTop: '10px',
    // textAlign: 'center'
    textAlign: 'left'
  },

  timerText: {
    fontSize: '0.9rem',
    marginBottom: '5px',
    color: '#ffffff'
  },

  timerDisplay: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '#ff4444',
    margin: '8px 0',
    textShadow: '0 0 5px rgba(255, 68, 68, 0.5)'
  },

  timerWarning: {
    fontSize: '0.8rem',
    marginTop: '5px',
    color: '#ffffff',
    fontStyle: 'italic'
  }
}
